import React from "react";

export const Biofuels = [
  <div className="slideContainer slide_solidColour noGutters">
    <div className="colLeft col50">
      <h4 class="slideTitle">Biofuels to lower emission from transportation</h4>
      <p>
        We are one of the{" "}
        <strong>largest blender and distributors of biofuels globally</strong>.
        We are also investing in the production of biofuels, including SAF,
        renewable diesel, and RNG, and working towards producing low carbon
        synthetic fuels.
      </p>
      <ul className="shell_bullets_list">
        <li>
          We invest in advanced biofuels using alternative feedstocks such
          as agricultural, municipal, and forestry waste
        </li>
        <li>
          We partner with governments to support goal of a lower carbon future
          through products and infrastructure
        </li>
        <li>
          We supply sustainable aviation fuel to our partners and customers,
          such as Amazon and Lufthansa, to contribute towards to decarbonizing
          their value chain.
        </li>
      </ul>
    </div>
    <div className="colRight col50 solidColourContainer stats">
      <p className="figureContainer">
        <span className="figure">&gt;9.5 bln</span>
        <br />
        Litres of biofuels blended in 2020
      </p>
      <p className="figureContainer">
        <span className="figure">&gt;2.5 bln</span>
        <br />
        Litres of sugar-cane ethanol produced in 2020 by Raizen
      </p>
    </div>
  </div>,
  <div className="slideContainer slide_solidColour noGutters">
    <div className="colLeft col50 backgroundImage">
      <img
        src="images/biofuels.jpg"
        width="100%"
        height="auto"
        alt=""
      />
    </div>
    <div className="colRight col50 solidColourContainer stats">
      <p>
        SAF results in up to{" "}
        <strong>
          80% less lifecycle CO<sub>2</sub> emissions
        </strong>{" "}
        compared to conventional aviation fuel.
      </p>
      <p>Delivered 6 Mln gallons of SAF in 2020 to Amazon Air Cargo.</p>
      <p>
        <strong>Shell Raízen 50/50 JV</strong> in Brazil produces one of the
        lowest CO<sub>2</sub> biofuels available today.
      </p>
    </div>
  </div>,
  <>
    <h4 class="slideTitle">Classificaion of Biofuel</h4>
    <div className="slideContainer slide_solidColour h-100">
      <div className="colLeft col30 h-100">
        <h4 className="slideTitle">1st Generation Biofuels</h4>
        <p>
          <strong>Crop Biofuel</strong>
        </p>
        <p>
          Biofuel made from Food Crop, that use farmland and compete with food
          sources.
        </p>
        <p>Sugarcane, corn and wheat produce ethanol.</p>
        <p>Rape seed, palm oil and soy bean produce fame.</p>
      </div>
      <div className="colLeft colRight col30 h-100">
        <h4 className="slideTitle">2nd Generation Biofuels</h4>
        <p>
          <strong>Other Biofuel</strong>
        </p>
        <p>Biofuel generated from animal fats and used cooking oils.</p>
      </div>
      <div className="colRight col30 solidColourContainer align-self-start">
        <h4 className="slideTitle">2nd Generation Advanced Biofuels</h4>
        <p>
          <strong>Advanced Biofuel</strong>
        </p>
        <p>
          Biofuels which do not use crops, used cooking oil, or waste animal
          fats as feedstock, for example: Palm Oil Mill Effluent
        </p>
      </div>
    </div>
  </>,
  <>
    <h4 class="slideTitle">Reduce emissions by turning used cooking oil into biofuel</h4>
    <div className="slideContainer slide_solidColour noGutters">
    <div className="colLeft col60">
      <img
        src="images/biofuelsCookingOil.jpg"
        width="100%"
        height="auto"
        alt=""
      />
    </div>
    <div className="colRight col40">
      <p className="number"><span>1</span> Feedstock arrives at Shell facility</p>
      <p className="number"><span>2</span> Pre-treatment Unit filters feedstock and prepares feedstock for processing</p>
      <p className="number"><span>3</span> Conversion to lower carbon fuels</p>
      <p className="number"><span>4</span> Lower carbon fuels are blended into products at Shell facility or shipped off to customers </p>
      <p><strong>Current footprint</strong></p>
      <ul className="shell_bullets_list">
        <li><strong>North America:</strong> Shell biofuels facility from 2024 in the US Gulf Coast region in addition to Shell Energy and Chemicals Park Scotford (Alberta, Canada)</li>
        <li><strong>Europe:</strong> FID biofuels facility at the Shell Energy and Chemicals Park Rotterdam</li>
      </ul>
      
    </div>
  </div>
  </>,
];
